module.exports = __webpack_public_path__ + "static/media/sumit.ebf7b3d6.jpg";